module.exports = __webpack_public_path__ + "static/logo-wortmarke-59a6ca748e6d66f2677ff3a14b7ed2ea.svg";